// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"b76cdc99","592":"1679aabe"}[chunkId] + ".chunk.js";
};